import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Badge } from "react-bootstrap";

const ButtonStatistic = (props) => (
    <Badge>
        <FontAwesomeIcon icon={['fas', props.icon]} className="mr-1" />
        {props.value}
    </Badge>
)

ButtonStatistic.defaultProps = {
    icon: 'fa-chart-column',
    value: 0
}
export default ButtonStatistic;
